var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite13859676(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.341,
    height: 23,
    viewBox: "0 0 14.341 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favorite_13859676",
    transform: "translate(-24.213 -2.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63164",
    "data-name": "Path 63164",
    d: "M24.3,2.5a.566.566,0,0,0,.092.719l3.669,3.669-2.673,3.6a4.208,4.208,0,0,0-.848,2.526V22.85a2.392,2.392,0,0,0,2.4,2.4h9.218a2.392,2.392,0,0,0,2.4-2.4V13.005a4.129,4.129,0,0,0-.848-2.526l-4.24-5.7a2.353,2.353,0,0,0-2.028-.959,2.508,2.508,0,0,0-1.862,1.014.342.342,0,0,0,.037.461l3.1,3.1v.018a1.7,1.7,0,0,1,.461,1.457,1.656,1.656,0,0,1-2.8.885H30.35v-.018a1.694,1.694,0,0,1-.461-1.162.364.364,0,0,1,.627-.24l.645.645a.535.535,0,0,0,.774,0,.535.535,0,0,0,0-.774L25.17,2.4A.572.572,0,0,0,24.3,2.5Zm4.111,14.086,1.751-.258a.354.354,0,0,0,.277-.2l.774-1.586a.369.369,0,0,1,.664,0l.774,1.586a.386.386,0,0,0,.277.2l1.751.258a.369.369,0,0,1,.2.627l-1.272,1.235a.372.372,0,0,0-.111.332l.295,1.733a.366.366,0,0,1-.535.387l-1.567-.83a.391.391,0,0,0-.35,0l-1.567.83a.366.366,0,0,1-.535-.387l.295-1.733a.389.389,0,0,0-.111-.332l-1.272-1.235A.4.4,0,0,1,28.414,16.582Z",
    transform: "translate(0 0)",
    fill: "#7d96ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite13859676);
export default __webpack_public_path__ + "static/media/favorite_13859676.efd578f91262218c8a0b0814258e22ce.svg";
export { ForwardRef as ReactComponent };